export default {
  title: {
    en: 'Sorry, but flash sale offer is no longer available.',
  },
  text: {
    en: 'We run multiple offers every month. Stay tuned!',
  },
  gotIt: {
    en: 'Got it',
  },
  backToMainPage: {
    en: 'Back to the main page',
  },
}
